import styled from "@emotion/styled";

export const CanvasWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: right;
  justify-content: center;
  width: 67%;
  background-image: linear-gradient(to right, #c4c4c4, #d9d9d9);
`;
